// Shared data and constants for VALOR site
export const NAV_LINKS = [
  { to: "/", label: "Home", code: "00" },
  { to: "/energetics", label: "Energetics", code: "01" },
  { to: "/mounts-mechanical", label: "Mounts & Mechanical", code: "02" },
  { to: "/capabilities", label: "Capabilities", code: "03" },
  { to: "/quality-testing", label: "Quality & Testing", code: "04" },
  { to: "/sustainability", label: "EHS", code: "05" },
  { to: "/about", label: "About", code: "06" },
  { to: "/careers", label: "Careers", code: "07" },
  // Insights: energetics articles and guides.
  { to: "/insights", label: "Insights", code: "08" },
  { to: "/contact-us", label: "Contact", code: "08" },
];

export const PAYLOCITY_URL =
  "https://recruiting.paylocity.com/recruiting/jobs/All/54907fb2-0a07-4338-b0aa-64243060d01d/Valor-Tactical-Innovation-LLC";

// Booking link — single Microsoft Bookings (or Cal.com) URL.
// When empty, calendar CTAs fall back to /contact.
export const CONTACT = {
  phoneDisplay: process.env.REACT_APP_PHONE_DISPLAY || "+1 (970) 243-8750",
  phoneTel: process.env.REACT_APP_PHONE_TEL || "+19702438750",
  email: "info@valortactical.us",
  // bookingUrl removed — all calendar CTAs now route to /contact form
  bookingUrl: "",
  get calUrl() {
    return this.bookingUrl;
  },
  hoursMT: "7:00 AM – 5:30 PM MT · Mon – Thu",
};

// Public social profiles — used in the footer + Organization JSON-LD `sameAs`.
export const SOCIAL = {
  linkedin: "https://www.linkedin.com/company/valortactical",
};

export const IMAGES = {
  jet: "https://images.unsplash.com/photo-1751983115035-c26697e0c247?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxmaWdodGVyJTIwamV0JTIwZmlyZXxlbnwwfHx8fDE3NzkzMTM5ODF8MA&ixlib=rb-4.1.0&q=85",
  missile:
    "https://images.unsplash.com/photo-1484600899469-230e8d1d59c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxtaXNzaWxlJTIwbGF1bmNofGVufDB8fHx8MTc3OTMxMzk4MXww&ixlib=rb-4.1.0&q=85",
  // Energetics — bullets / cartridges / ammunition imagery
  energeticsHero:
    "https://images.unsplash.com/photo-1518365050014-70fe7232897f?fm=jpg&q=85&w=2400&auto=format&fit=crop",
  bulletsDark:
    "https://images.unsplash.com/photo-1749764437940-07061e84d871?fm=jpg&q=80&w=1920&auto=format&fit=crop",
  bulletsClose:
    "https://images.unsplash.com/photo-1552257127-151dd9bcc678?fm=jpg&q=80&w=1920&auto=format&fit=crop",
  bulletsBrass:
    "https://images.unsplash.com/photo-1552257128-c1a71b6736d4?fm=jpg&q=80&w=1920&auto=format&fit=crop",
  casingsBunch:
    "https://images.unsplash.com/photo-1646744864913-72d5e14be2b2?fm=jpg&q=80&w=1920&auto=format&fit=crop",
  casingsGround:
    "https://images.unsplash.com/photo-1671404910911-3a3684a9b838?fm=jpg&q=80&w=1920&auto=format&fit=crop",
  bulletGold:
    "https://images.unsplash.com/photo-1598390367635-55152e31ec07?fm=jpg&q=80&w=1920&auto=format&fit=crop",
  ammoBW:
    "https://images.unsplash.com/photo-1550318496-399db15aa7e6?fm=jpg&q=80&w=1920&auto=format&fit=crop",
  bulletsMacro:
    "https://images.unsplash.com/photo-1748791582472-eadb06565a05?fm=jpg&q=80&w=1920&auto=format&fit=crop",
  casingsTable:
    "https://images.unsplash.com/photo-1704635819045-4696541f154c?fm=jpg&q=80&w=1920&auto=format&fit=crop",
  // Rockets / jets / launches — explosive imagery
  fighterFlares:
    "https://customer-assets.emergentagent.com/job_mission-critical-hub/artifacts/m0nvy14t_64bc40b576f02c3a8cfadc8b_Energetics-p-2000.webp",
  cartridgesInAction:
    "https://customer-assets.emergentagent.com/job_mission-critical-hub/artifacts/f3k1bgdq_AdobeStock_114407571.jpeg",
  rocketFlames:
    "https://images.unsplash.com/photo-1518365050014-70fe7232897f?fm=jpg&q=85&w=1920&auto=format&fit=crop",
  challenger:
    "https://images.unsplash.com/photo-1614728263952-84ea256f9679?fm=jpg&q=85&w=1920&auto=format&fit=crop",
  lightStreak:
    "https://images.unsplash.com/photo-1457364887197-9150188c107b?fm=jpg&q=85&w=1920&auto=format&fit=crop",
  daytimeLaunch:
    "https://images.unsplash.com/photo-1541185933-ef5d8ed016c2?fm=jpg&q=85&w=1920&auto=format&fit=crop",
  cosmicTrail:
    "https://images.unsplash.com/photo-1457365050282-c53d772ef8b2?fm=jpg&q=85&w=1920&auto=format&fit=crop",
  soyuzLaunch:
    "https://images.unsplash.com/photo-1614642240262-a452c2c11724?fm=jpg&q=85&w=1920&auto=format&fit=crop",
  rocketSpace:
    "https://images.unsplash.com/photo-1516849841032-87cbac4d88f7?fm=jpg&q=85&w=1920&auto=format&fit=crop",
  spaceShuttle:
    "https://images.unsplash.com/photo-1518364538800-6bae3c2ea0f2?fm=jpg&q=85&w=1920&auto=format&fit=crop",
  nightLaunch:
    "https://images.unsplash.com/photo-1541186877-bb5a745edde5?fm=jpg&q=85&w=1920&auto=format&fit=crop",
  // Cartridge product photography (AI-generated where available, stock fallback)
  ccu136a: `${process.env.REACT_APP_BACKEND_URL || ""}/api/static/cartridges/ccu-136a.png`,
  ccu145a: `${process.env.REACT_APP_BACKEND_URL || ""}/api/static/cartridges/ccu-145a.png`,
  // Mounts & Mechanical
  // User-supplied licensed asset — soldier behind M205 tripod.
  // Original was 12328×6486 / 14MB JPEG — we serve our own pre-resized WebP
  // variants from the backend (111 KB / 236 KB) to fix scroll-paint lag.
  mountsHero: `${process.env.REACT_APP_BACKEND_URL || ""}/api/static/mounts/soldier_m205_lg.webp`,
  soldierM205: `${process.env.REACT_APP_BACKEND_URL || ""}/api/static/mounts/soldier_m205_md.webp`,
  soldierM205Lg: `${process.env.REACT_APP_BACKEND_URL || ""}/api/static/mounts/soldier_m205_lg.webp`,
  // CNC machining shot (kept for other potential uses)
  cncMachining:
    "https://customer-assets.emergentagent.com/job_mission-critical-hub/artifacts/sjw77wlk_AdobeStock_172041089.jpeg",
  // Heavy machine gun on tripod (kept as fallback)
  tripodGun:
    "https://images.unsplash.com/photo-1759203977900-2f83bf81dcaa?fm=jpg&q=80&w=2400&auto=format&fit=crop",
  // Real Valor Tactical product imagery (M&M)
  m205:
    "/media/mounts/m205-tripod.webp",
  m192:
    "/media/mounts/m192-tripod.webp",
  atem:
    "/media/mounts/atem-mechanism.webp",
  m4Barrels:
    "/media/mounts/m4-barrel.webp",
  m16Barrels:
    "/media/mounts/m16-barrel.webp",
  customBarrels:
    "/media/mounts/custom-barrel.webp",

  // ── Cinematic editorial image bands (Unsplash · royalty-free) ──
  // Capabilities — sparks-from-welding band
  factoryFloor:
    "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?fm=jpg&q=80&w=2400&auto=format&fit=crop",
  // Quality & Testing — clean lab / engineering inspection
  qualityLab:
    "https://images.unsplash.com/photo-1581094794329-c8112a89af12?fm=jpg&q=80&w=2400&auto=format&fit=crop",
  // About — engineer reviewing blueprint
  engineerBlueprint:
    "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?fm=jpg&q=80&w=2400&auto=format&fit=crop",
  // Careers — workforce in industrial setting
  workforce:
    "https://images.unsplash.com/photo-1556761175-4b46a572b786?fm=jpg&q=80&w=2400&auto=format&fit=crop",
  // EHS — green manufacturing / sustainability
  environmental:
    "https://customer-assets.emergentagent.com/job_mission-critical-hub/artifacts/cjehpqfk_engineer-quality.jpg",
};

export const STATS = [
  { value: "2M+", label: "Cartridges Produced Annually", code: "01" },
  { value: "24 HOURS", label: "Initial Response", code: "02" },
  { value: "ISO 9001", label: "Quality Management Certified", code: "03" },
  { value: "ITAR", label: "Registered · Export-Controlled Operations", code: "04" },
];

export const CAPABILITIES = [
  {
    code: "C-01",
    title: "Energetics Manufacturing",
    desc: "Specialized energetics manufacturing from formulation through final assembly, engineered for mission-critical performance and production-scale delivery.",
    bullets: ["Pyrotechnics", "Initiators", "Propellant Charges", "Lead & Booster Charges"],
  },
  {
    code: "C-02",
    title: "Advanced Materials Processing",
    desc: "Precision machining and processing of advanced alloys, composites, and specialty materials for demanding defense applications.",
    bullets: ["CNC Machining", "Surface Finishing", "Composite Fabrication", "Precision Bonding"],
  },
  {
    code: "C-03",
    title: "Hermetic Assembly",
    desc: "Hermetically sealed assemblies produced in controlled environments with lot-level traceability and documented quality controls.",
    bullets: ["Glass-to-Metal Seals", "Laser Welding", "Leak Testing"],
  },
  {
    code: "C-04",
    title: "Qualification Testing",
    desc: "MIL-STD qualification testing performed on-site to validate performance across environmental and operational conditions.",
    bullets: ["Vibration Testing", "Shock Testing", "Thermal Testing", "Functional Testing"],
  },
  {
    code: "C-05",
    title: "Quality Control & Inspection",
    desc: "Comprehensive quality control processes supporting incoming inspection, in-process verification, lot acceptance, and serialized traceability.",
    bullets: ["Incoming Inspection", "In-Process Verification", "Lot Acceptance Testing (LAT)", "Serialized Traceability"],
    wide: true,
  },
];
